import { ReactComponent as BackIcon } from 'Assets/icons/back.svg';
import { SharedItemsPageHeaderProps } from 'Modules/sharedItems/components/SharedItemsPageHeader/index.types';
import React from 'react';
import { IconButton } from '~/lib/ui/icon-button';

export const SharedItemsPageHeader: React.FC<SharedItemsPageHeaderProps> = ({
  conversationName,
  onBack,
}) => (
  <div
    id="context-header"
    className="semantic-flex-row semantic-flex-zero items-center justify-start gap-6"
  >
    <IconButton
      icon={BackIcon}
      onClick={onBack}
      ariaLabel="Back to chat"
      testID="shared-files-and-links-back-button"
    />
    <div className="semantic-flex-column flex min-w-0 flex-col">
      <span className="text-[16px] font-bold leading-[21px]">
        Shared files & links
      </span>
      <span className="truncate text-[13px] leading-[18px]">
        {conversationName}
      </span>
    </div>
  </div>
);